
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexuBsWoMeQ_d8w8D_L0Mwo6zTf3WU5Dl_45g89Px0TrLqQQMeta } from "/usr/src/app/src/pages/index.vue?macro=true";
import { default as loginG1ModxHzsvShKQFJLO27FQl_E5QrBSpaokXhcGWF6YQMeta } from "/usr/src/app/src/pages/login.vue?macro=true";
import { default as beginnerHuDRr8ig_45nXgJEfmmP6j5BmgxgvYPvmk98NfXYWJbF8Meta } from "/usr/src/app/src/pages/beginner.vue?macro=true";
import { default as _1umUfuuR_456GraMI38Bf3IszYjkat3udVa35U1dpVdLUMMeta } from "/usr/src/app/src/pages/regist/1.vue?macro=true";
import { default as _2XH74NS2bcJZCwBN90kH0bGo3a_45ha0SQ2sTlqZg7cGcIMeta } from "/usr/src/app/src/pages/regist/2.vue?macro=true";
import { default as _31XPtca_hKvD25lKHrmcYghOfI_V4P7fAAu0QsiF7BBwMeta } from "/usr/src/app/src/pages/regist/3.vue?macro=true";
import { default as _4ejtKjjrClVLyLdRu1Nq9RSPDG3aKlRRTAAUEfRBX38gMeta } from "/usr/src/app/src/pages/regist/4.vue?macro=true";
import { default as tagl_45LZiOisPJPtpAFctK2yqxpkRYNQF25di7FSkoPL6JoMeta } from "/usr/src/app/src/pages/admin/tag.vue?macro=true";
import { default as _91slug_93tEYf9mPLyiZes0kDY4a_45L3wzg4__45N3_456TKowu0OQUL0Meta } from "/usr/src/app/src/pages/pub/[slug].vue?macro=true";
import { default as indexclXEQqHGNQk5vrAQUl0GqFgUMrNeXwl9WfpwwQzerckMeta } from "/usr/src/app/src/pages/admin/index.vue?macro=true";
import { default as logineRO_45GxVksqkS7xTIcEsNkaeFScNuGy78K8XrAlomkEkMeta } from "/usr/src/app/src/pages/admin/login.vue?macro=true";
import { default as infot_45brzIEPSdCVjcyJmZKqF9rcv25QyEz1vTg_V48PZNsMeta } from "/usr/src/app/src/pages/mypage/info.vue?macro=true";
import { default as _91slug_93rxNF8CvCL967lM6clyCQRbf18jhl0uZpBa9ao_45Rx19wMeta } from "/usr/src/app/src/pages/page/[slug].vue?macro=true";
import { default as index_iQplwFSD1yfLLB_458UvIARMr3PK_yVxRAEMdGe0ZdT4Meta } from "/usr/src/app/src/pages/setup/index.vue?macro=true";
import { default as _91id_93Jzp0_KykVbHZHNoG8qfNzPKdatEC4_sOjgjIXa424cMMeta } from "/usr/src/app/src/pages/article/[id].vue?macro=true";
import { default as indextgOtVUy8OH6bROJynLeKoRF8B8WmD6slK_S5PTqYAZUMeta } from "/usr/src/app/src/pages/mypage/index.vue?macro=true";
import { default as indexEMpOa6hZKbDCpBfpn3_VsDIBEC9W6XH0xULLNnTDh6kMeta } from "/usr/src/app/src/pages/regist/index.vue?macro=true";
import { default as _03sitei26y2wCXXqUGhX_qJSHdTq91y4ekdh5h1qmaPLeuYUQMeta } from "/usr/src/app/src/pages/setup/03site.vue?macro=true";
import { default as _04smtpdkKSWrNHcJl_45mvE64UMyoleHVAu0xHIOm0IzS4xwF5IMeta } from "/usr/src/app/src/pages/setup/04smtp.vue?macro=true";
import { default as indexn8sQAy5EmUnSJI4NfunGTT756g2XLkMXfU_cWGYvWe4Meta } from "/usr/src/app/src/pages/article/index.vue?macro=true";
import { default as indexaYYoYyDd4Kx4pb_uK_HU_Y_c810rMRpva0KFvHEJHA8Meta } from "/usr/src/app/src/pages/contact/index.vue?macro=true";
import { default as index4fgWNczNRtQRsBw2u2ZrF7b_1E3C_453qbksKqJZCjJ14Meta } from "/usr/src/app/src/pages/recover/index.vue?macro=true";
import { default as completeKsvl1KX9TJcnpWXfng_45H60BqnYRzGrVfR0NAUNmkFI0Meta } from "/usr/src/app/src/pages/point/complete.vue?macro=true";
import { default as confirm4gGPdw9vdP2GPjeg5qD62AmU0JSgj50AFsNJ0MDvzcgMeta } from "/usr/src/app/src/pages/regist/confirm.vue?macro=true";
import { default as complete7v17mGOGB3x2oSrhUD_45Y_45cPpj_45CyPqqkP_Dgs3PdoNUMeta } from "/usr/src/app/src/pages/setup/complete.vue?macro=true";
import { default as _91id_937H2_fmsIlVndeopkbeDsEsxz9XpiBkGIXruqzPq72QsMeta } from "/usr/src/app/src/pages/admin/page/[id].vue?macro=true";
import { default as favoriteLuC90h5JlYG7g4neiI6wb2RBmk_45J03G4g7tsGtanKtcMeta } from "/usr/src/app/src/pages/mypage/favorite.vue?macro=true";
import { default as completeNJsXRkDIbG6tl19P0GFJXarBzR2dVgXNcFiheSZGcasMeta } from "/usr/src/app/src/pages/regist/complete.vue?macro=true";
import { default as _01companyVzbrZM_ycaeCr8ncDnNK0Ocfrjv0D6mNOBVOTUzBRiUMeta } from "/usr/src/app/src/pages/setup/01company.vue?macro=true";
import { default as _02storage66V8geypcWqKBGlAn6IQkoRbAnGzJjYkP7_45KW9t0u8IMeta } from "/usr/src/app/src/pages/setup/02storage.vue?macro=true";
import { default as _05accountkLDEzPPL5y6y30pjffBm4Y6iHZyj_e_45sv8Kp6yqoKXsMeta } from "/usr/src/app/src/pages/setup/05account.vue?macro=true";
import { default as _06confirmzUmHWtqcupaZ4sAbMoflB_2HfDgJknuBLTPuXkQRI0cMeta } from "/usr/src/app/src/pages/setup/06confirm.vue?macro=true";
import { default as indexxgfmNk_45m5uTUMmaQ0b9fIKa_45oOyYiyEkzKX7Vog_459YkMeta } from "/usr/src/app/src/pages/admin/page/index.vue?macro=true";
import { default as completedyBniEOzU_45if_8_ITH9kQ2gmdIGjlvpcdEvp_45qdyxEIMeta } from "/usr/src/app/src/pages/contact/complete.vue?macro=true";
import { default as _91id_93GnIFA_45UkcnYJzwkfdg6ugxtz4AdIC2nTTr_mpkSRR1EMeta } from "/usr/src/app/src/pages/admin/account/[id].vue?macro=true";
import { default as _91id_93mjXjh7JIq4FtwpgxKX_zoKGr8KSDez1nEjVEOfwmJUIMeta } from "/usr/src/app/src/pages/admin/article/[id].vue?macro=true";
import { default as indexOT_ovrCcc6fxFLz37NX8Kn1c_fkKT0LZHRaxsD3GIcAMeta } from "/usr/src/app/src/pages/admin/account/index.vue?macro=true";
import { default as indexwscDqmEqmw12_45tLTgpYor9UUa1_BQihBGKzioAFpQKQMeta } from "/usr/src/app/src/pages/admin/article/index.vue?macro=true";
import { default as _91id_930FHiVIL_y_45UrTNTb9siTvwXCeDgfFfcH98By0urtdaMMeta } from "/usr/src/app/src/pages/admin/category/[id].vue?macro=true";
import { default as indexlaPB0VLhB_45IjGPQxfJNd9z0JwDYTL8l3lmCuDhSrqNkMeta } from "/usr/src/app/src/pages/admin/gallery/index.vue?macro=true";
import { default as _91id_93Y5BStSBV8Lu3TaUhojl1PKN3cvx_ksHZKABwofN05fUMeta } from "/usr/src/app/src/pages/admin/producer/[id].vue?macro=true";
import { default as emailJ30wPRHxGKp2sC4eTqskmbD4TrTRbTCTM_45Rbh0RceoIMeta } from "/usr/src/app/src/pages/admin/setting/email.vue?macro=true";
import { default as indexu9esT1Qx6J586Cw2I8ihGLABcXKCtNg1ebFE8f0IUeEMeta } from "/usr/src/app/src/pages/admin/setting/index.vue?macro=true";
import { default as _91provider_93dL_8_450NleZ2NaDanJtasoDKvh_G1dtoGDCL0tWCf57QMeta } from "/usr/src/app/src/pages/callback/[provider].vue?macro=true";
import { default as paidWwVkZA9tEMntPsztPdSn4F7U3VrzU3yx9AqXzVD3G4EMeta } from "/usr/src/app/src/pages/mypage/history/paid.vue?macro=true";
import { default as indexWACZlvUbL78xobOc8Kci_gFnhoHtEEFz2wts5dogB2oMeta } from "/usr/src/app/src/pages/account/regist/index.vue?macro=true";
import { default as indexAwn2bJb6_qU_0GzWhWWtI7xJFLcwyShd330E9lSIAE8Meta } from "/usr/src/app/src/pages/admin/category/index.vue?macro=true";
import { default as indexC7b713URYHpAB9ZFd40NZ52kda5wGWWHslQ_45MpOCGGEMeta } from "/usr/src/app/src/pages/admin/producer/index.vue?macro=true";
import { default as loginTuDaAPFdqy4WewEfNhESDggNo0xslOQ7t6bGozW5CBMMeta } from "/usr/src/app/src/pages/mypage/history/login.vue?macro=true";
import { default as indexT2VEdO6wdKVNWu2kjIZ_455l2yz1w6To0prJCAV4qJb2MMeta } from "/usr/src/app/src/pages/account/recover/index.vue?macro=true";
import { default as accountyqoa_x_IYpXVo0XOCgwtF_JnbrsLvvBdj0px2hUrFHsMeta } from "/usr/src/app/src/pages/admin/setting/account.vue?macro=true";
import { default as paymentp7OsGagCZIiDW686s_45EBqX0Zq_6R_45rnAZ_Q_45FsANKAcMeta } from "/usr/src/app/src/pages/admin/setting/payment.vue?macro=true";
import { default as indexv0XU6yDmU4XzNZrbNnCdrGFYpoFU3zdenayR5TM7Q5kMeta } from "/usr/src/app/src/pages/mypage/producer/index.vue?macro=true";
import { default as index8wJ64sstDaXLfxK4tzKAzvx39wE6JYXk3oUQqiMzXWYMeta } from "/usr/src/app/src/pages/producer/[cuid]/index.vue?macro=true";
import { default as confirmZ6_45hGV7_DXB_Ucq_OH5LR2BvBLIOHhUX_45t7sZJ_UFw8Meta } from "/usr/src/app/src/pages/account/regist/confirm.vue?macro=true";
import { default as categoryL3mEDRk2B9iwjTtE8TyyvBNLCcxW7w3vNN9Gbn3WOfMMeta } from "/usr/src/app/src/pages/admin/article/category.vue?macro=true";
import { default as detailYai4WCfkImsNS84KRQ9ATYmw27Xgn0s1fl238Vzz1NIMeta } from "/usr/src/app/src/pages/producer/[cuid]/detail.vue?macro=true";
import { default as completeqX_45rJlr2Rhfm_45TSwRctjdFVqGOo65IBIv2rRboau8FoMeta } from "/usr/src/app/src/pages/account/regist/complete.vue?macro=true";
import { default as producerp_45g31CbTvs9uh0jCzEqxq3xhAFRu0g4yrrJUCCL0JyEMeta } from "/usr/src/app/src/pages/account/regist/producer.vue?macro=true";
import { default as agreementMWm37zikHFVoy9pNGm6uCN6gKbUoSW2SmuIZppi8XsIMeta } from "/usr/src/app/src/pages/admin/setting/agreement.vue?macro=true";
import { default as confirmQQLVZvXzERri3sbIslEJq8nCFdYvCT0BtqeURpBKVOwMeta } from "/usr/src/app/src/pages/mypage/producer/confirm.vue?macro=true";
import { default as completeh7EAUswj4VscNCzFBJ3sqASeLavwM4jD293ylTkHsDAMeta } from "/usr/src/app/src/pages/account/recover/complete.vue?macro=true";
import { default as indexqDFf7yhh_aVMHYSHGV68R_FohOqWmoybRgq3s82R_45MoMeta } from "/usr/src/app/src/pages/account/withdrawal/index.vue?macro=true";
import { default as completeJRQbhKABzbEGPTKCdTHwJKgnsNgXSUVt8fQHe5XyzokMeta } from "/usr/src/app/src/pages/mypage/producer/complete.vue?macro=true";
import { default as drawer_45linksckM6_LMfy81fP2xRaGXqxNfRvTkxEw2xzj849qiYja0Meta } from "/usr/src/app/src/pages/admin/setting/drawer-links.vue?macro=true";
import { default as completeRrHIkOVOm1Cp5EM1MPBEylpC7XzEcSiICnfFRCRVOQoMeta } from "/usr/src/app/src/pages/account/withdrawal/complete.vue?macro=true";
import { default as index22Wr56U5PLnv_NXHQWo7xTu2ZL4mqgLr81RicFnRQIsMeta } from "/usr/src/app/src/pages/account/recover/password/index.vue?macro=true";
import { default as completefx9zUODOd_45X1CVXw3645NXT60Ljr_45cFT5QYRdPloxckMeta } from "/usr/src/app/src/pages/account/recover/password/complete.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/usr/src/app/src/pages/login.vue")
  },
  {
    name: "beginner",
    path: "/beginner",
    component: () => import("/usr/src/app/src/pages/beginner.vue")
  },
  {
    name: "regist-1",
    path: "/regist/1",
    component: () => import("/usr/src/app/src/pages/regist/1.vue")
  },
  {
    name: "regist-2",
    path: "/regist/2",
    component: () => import("/usr/src/app/src/pages/regist/2.vue")
  },
  {
    name: "regist-3",
    path: "/regist/3",
    component: () => import("/usr/src/app/src/pages/regist/3.vue")
  },
  {
    name: "regist-4",
    path: "/regist/4",
    component: () => import("/usr/src/app/src/pages/regist/4.vue")
  },
  {
    name: "admin-tag",
    path: "/admin/tag",
    meta: tagl_45LZiOisPJPtpAFctK2yqxpkRYNQF25di7FSkoPL6JoMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/tag.vue")
  },
  {
    name: "pub-slug",
    path: "/pub/:slug()",
    component: () => import("/usr/src/app/src/pages/pub/[slug].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexclXEQqHGNQk5vrAQUl0GqFgUMrNeXwl9WfpwwQzerckMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    meta: logineRO_45GxVksqkS7xTIcEsNkaeFScNuGy78K8XrAlomkEkMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/login.vue")
  },
  {
    name: "mypage-info",
    path: "/mypage/info",
    meta: infot_45brzIEPSdCVjcyJmZKqF9rcv25QyEz1vTg_V48PZNsMeta || {},
    component: () => import("/usr/src/app/src/pages/mypage/info.vue")
  },
  {
    name: "page-slug",
    path: "/page/:slug()",
    component: () => import("/usr/src/app/src/pages/page/[slug].vue")
  },
  {
    name: "setup",
    path: "/setup",
    meta: index_iQplwFSD1yfLLB_458UvIARMr3PK_yVxRAEMdGe0ZdT4Meta || {},
    component: () => import("/usr/src/app/src/pages/setup/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/usr/src/app/src/pages/article/[id].vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: indextgOtVUy8OH6bROJynLeKoRF8B8WmD6slK_S5PTqYAZUMeta || {},
    component: () => import("/usr/src/app/src/pages/mypage/index.vue")
  },
  {
    name: "regist",
    path: "/regist",
    component: () => import("/usr/src/app/src/pages/regist/index.vue")
  },
  {
    name: "setup-03site",
    path: "/setup/03site",
    meta: _03sitei26y2wCXXqUGhX_qJSHdTq91y4ekdh5h1qmaPLeuYUQMeta || {},
    component: () => import("/usr/src/app/src/pages/setup/03site.vue")
  },
  {
    name: "setup-04smtp",
    path: "/setup/04smtp",
    meta: _04smtpdkKSWrNHcJl_45mvE64UMyoleHVAu0xHIOm0IzS4xwF5IMeta || {},
    component: () => import("/usr/src/app/src/pages/setup/04smtp.vue")
  },
  {
    name: "article",
    path: "/article",
    component: () => import("/usr/src/app/src/pages/article/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/usr/src/app/src/pages/contact/index.vue")
  },
  {
    name: "recover",
    path: "/recover",
    component: () => import("/usr/src/app/src/pages/recover/index.vue")
  },
  {
    name: "point-complete",
    path: "/point/complete",
    component: () => import("/usr/src/app/src/pages/point/complete.vue")
  },
  {
    name: "regist-confirm",
    path: "/regist/confirm",
    component: () => import("/usr/src/app/src/pages/regist/confirm.vue")
  },
  {
    name: "setup-complete",
    path: "/setup/complete",
    meta: complete7v17mGOGB3x2oSrhUD_45Y_45cPpj_45CyPqqkP_Dgs3PdoNUMeta || {},
    component: () => import("/usr/src/app/src/pages/setup/complete.vue")
  },
  {
    name: "admin-page-id",
    path: "/admin/page/:id()",
    meta: _91id_937H2_fmsIlVndeopkbeDsEsxz9XpiBkGIXruqzPq72QsMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/page/[id].vue")
  },
  {
    name: "mypage-favorite",
    path: "/mypage/favorite",
    meta: favoriteLuC90h5JlYG7g4neiI6wb2RBmk_45J03G4g7tsGtanKtcMeta || {},
    component: () => import("/usr/src/app/src/pages/mypage/favorite.vue")
  },
  {
    name: "regist-complete",
    path: "/regist/complete",
    component: () => import("/usr/src/app/src/pages/regist/complete.vue")
  },
  {
    name: "setup-01company",
    path: "/setup/01company",
    meta: _01companyVzbrZM_ycaeCr8ncDnNK0Ocfrjv0D6mNOBVOTUzBRiUMeta || {},
    component: () => import("/usr/src/app/src/pages/setup/01company.vue")
  },
  {
    name: "setup-02storage",
    path: "/setup/02storage",
    meta: _02storage66V8geypcWqKBGlAn6IQkoRbAnGzJjYkP7_45KW9t0u8IMeta || {},
    component: () => import("/usr/src/app/src/pages/setup/02storage.vue")
  },
  {
    name: "setup-05account",
    path: "/setup/05account",
    meta: _05accountkLDEzPPL5y6y30pjffBm4Y6iHZyj_e_45sv8Kp6yqoKXsMeta || {},
    component: () => import("/usr/src/app/src/pages/setup/05account.vue")
  },
  {
    name: "setup-06confirm",
    path: "/setup/06confirm",
    meta: _06confirmzUmHWtqcupaZ4sAbMoflB_2HfDgJknuBLTPuXkQRI0cMeta || {},
    component: () => import("/usr/src/app/src/pages/setup/06confirm.vue")
  },
  {
    name: "admin-page",
    path: "/admin/page",
    meta: indexxgfmNk_45m5uTUMmaQ0b9fIKa_45oOyYiyEkzKX7Vog_459YkMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/page/index.vue")
  },
  {
    name: "contact-complete",
    path: "/contact/complete",
    component: () => import("/usr/src/app/src/pages/contact/complete.vue")
  },
  {
    name: "admin-account-id",
    path: "/admin/account/:id()",
    meta: _91id_93GnIFA_45UkcnYJzwkfdg6ugxtz4AdIC2nTTr_mpkSRR1EMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/account/[id].vue")
  },
  {
    name: "admin-article-id",
    path: "/admin/article/:id()",
    meta: _91id_93mjXjh7JIq4FtwpgxKX_zoKGr8KSDez1nEjVEOfwmJUIMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/article/[id].vue")
  },
  {
    name: "admin-account",
    path: "/admin/account",
    meta: indexOT_ovrCcc6fxFLz37NX8Kn1c_fkKT0LZHRaxsD3GIcAMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/account/index.vue")
  },
  {
    name: "admin-article",
    path: "/admin/article",
    meta: indexwscDqmEqmw12_45tLTgpYor9UUa1_BQihBGKzioAFpQKQMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/article/index.vue")
  },
  {
    name: "admin-category-id",
    path: "/admin/category/:id()",
    meta: _91id_930FHiVIL_y_45UrTNTb9siTvwXCeDgfFfcH98By0urtdaMMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/category/[id].vue")
  },
  {
    name: "admin-gallery",
    path: "/admin/gallery",
    meta: indexlaPB0VLhB_45IjGPQxfJNd9z0JwDYTL8l3lmCuDhSrqNkMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/gallery/index.vue")
  },
  {
    name: "admin-producer-id",
    path: "/admin/producer/:id()",
    meta: _91id_93Y5BStSBV8Lu3TaUhojl1PKN3cvx_ksHZKABwofN05fUMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/producer/[id].vue")
  },
  {
    name: "admin-setting-email",
    path: "/admin/setting/email",
    meta: emailJ30wPRHxGKp2sC4eTqskmbD4TrTRbTCTM_45Rbh0RceoIMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/setting/email.vue")
  },
  {
    name: "admin-setting",
    path: "/admin/setting",
    meta: indexu9esT1Qx6J586Cw2I8ihGLABcXKCtNg1ebFE8f0IUeEMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/setting/index.vue")
  },
  {
    name: "callback-provider",
    path: "/callback/:provider()",
    component: () => import("/usr/src/app/src/pages/callback/[provider].vue")
  },
  {
    name: "mypage-history-paid",
    path: "/mypage/history/paid",
    component: () => import("/usr/src/app/src/pages/mypage/history/paid.vue")
  },
  {
    name: "account-regist",
    path: "/account/regist",
    component: () => import("/usr/src/app/src/pages/account/regist/index.vue")
  },
  {
    name: "admin-category",
    path: "/admin/category",
    meta: indexAwn2bJb6_qU_0GzWhWWtI7xJFLcwyShd330E9lSIAE8Meta || {},
    component: () => import("/usr/src/app/src/pages/admin/category/index.vue")
  },
  {
    name: "admin-producer",
    path: "/admin/producer",
    meta: indexC7b713URYHpAB9ZFd40NZ52kda5wGWWHslQ_45MpOCGGEMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/producer/index.vue")
  },
  {
    name: "mypage-history-login",
    path: "/mypage/history/login",
    component: () => import("/usr/src/app/src/pages/mypage/history/login.vue")
  },
  {
    name: "account-recover",
    path: "/account/recover",
    component: () => import("/usr/src/app/src/pages/account/recover/index.vue")
  },
  {
    name: "admin-setting-account",
    path: "/admin/setting/account",
    component: () => import("/usr/src/app/src/pages/admin/setting/account.vue")
  },
  {
    name: "admin-setting-payment",
    path: "/admin/setting/payment",
    meta: paymentp7OsGagCZIiDW686s_45EBqX0Zq_6R_45rnAZ_Q_45FsANKAcMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/setting/payment.vue")
  },
  {
    name: "mypage-producer",
    path: "/mypage/producer",
    component: () => import("/usr/src/app/src/pages/mypage/producer/index.vue")
  },
  {
    name: "producer-cuid",
    path: "/producer/:cuid()",
    component: () => import("/usr/src/app/src/pages/producer/[cuid]/index.vue")
  },
  {
    name: "account-regist-confirm",
    path: "/account/regist/confirm",
    component: () => import("/usr/src/app/src/pages/account/regist/confirm.vue")
  },
  {
    name: "admin-article-category",
    path: "/admin/article/category",
    meta: categoryL3mEDRk2B9iwjTtE8TyyvBNLCcxW7w3vNN9Gbn3WOfMMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/article/category.vue")
  },
  {
    name: "producer-cuid-detail",
    path: "/producer/:cuid()/detail",
    component: () => import("/usr/src/app/src/pages/producer/[cuid]/detail.vue")
  },
  {
    name: "account-regist-complete",
    path: "/account/regist/complete",
    component: () => import("/usr/src/app/src/pages/account/regist/complete.vue")
  },
  {
    name: "account-regist-producer",
    path: "/account/regist/producer",
    component: () => import("/usr/src/app/src/pages/account/regist/producer.vue")
  },
  {
    name: "admin-setting-agreement",
    path: "/admin/setting/agreement",
    meta: agreementMWm37zikHFVoy9pNGm6uCN6gKbUoSW2SmuIZppi8XsIMeta || {},
    component: () => import("/usr/src/app/src/pages/admin/setting/agreement.vue")
  },
  {
    name: "mypage-producer-confirm",
    path: "/mypage/producer/confirm",
    component: () => import("/usr/src/app/src/pages/mypage/producer/confirm.vue")
  },
  {
    name: "account-recover-complete",
    path: "/account/recover/complete",
    component: () => import("/usr/src/app/src/pages/account/recover/complete.vue")
  },
  {
    name: "account-withdrawal",
    path: "/account/withdrawal",
    component: () => import("/usr/src/app/src/pages/account/withdrawal/index.vue")
  },
  {
    name: "mypage-producer-complete",
    path: "/mypage/producer/complete",
    component: () => import("/usr/src/app/src/pages/mypage/producer/complete.vue")
  },
  {
    name: "admin-setting-drawer-links",
    path: "/admin/setting/drawer-links",
    meta: drawer_45linksckM6_LMfy81fP2xRaGXqxNfRvTkxEw2xzj849qiYja0Meta || {},
    component: () => import("/usr/src/app/src/pages/admin/setting/drawer-links.vue")
  },
  {
    name: "account-withdrawal-complete",
    path: "/account/withdrawal/complete",
    meta: completeRrHIkOVOm1Cp5EM1MPBEylpC7XzEcSiICnfFRCRVOQoMeta || {},
    component: () => import("/usr/src/app/src/pages/account/withdrawal/complete.vue")
  },
  {
    name: "account-recover-password",
    path: "/account/recover/password",
    component: () => import("/usr/src/app/src/pages/account/recover/password/index.vue")
  },
  {
    name: "account-recover-password-complete",
    path: "/account/recover/password/complete",
    component: () => import("/usr/src/app/src/pages/account/recover/password/complete.vue")
  }
]